const issues = {
  sports_watch_number_missing: 'No EPG channel number',
  sports_watch_number_ambiguous: 'Channel number is shared',
  sports_watch_channel_unavailable: 'Channel or guide is no longer available. Reload the guide.',
  sports_watch_app_unavailable: 'Connect and save this app’s guide in Setup.',
  sports_watch_input_setup_required: 'Train and enable the TV input routine in Site Control → Input Training.',
  sports_watch_route_test_required: 'Test this guide channel and confirm the picture to enable Watch Now.',
  sports_watch_channel_test_required: 'App playback is confirmed. Test a guide channel to confirm the keypad controls.',
};
export const watchReadinessText = (channel) => issues[channel.watchIssue]
  || (channel.channelNumber ? 'Review the app and guide settings in Setup.' : 'No EPG channel number');
export const watchSetupHref = (channel) => channel.watchIssue === 'sports_watch_input_setup_required'
  ? '/control-panel?tab=Site%20Control' : '/control-panel?tab=Fixtures';
